const socialMedias = [
  {
    id: "instagram",
    logo: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.6"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0001 -0.00133404C8.87147 -0.00133404 8.47916 0.0119273 7.25043 0.0679907C6.02426 0.123917 5.18683 0.318676 4.45407 0.603474C3.69653 0.89783 3.05409 1.29174 2.41361 1.93217C1.77318 2.57264 1.37927 3.21509 1.08492 3.97263C0.800121 4.70539 0.605362 5.54281 0.549436 6.76898C0.493373 7.99771 0.480111 8.39002 0.480111 11.5187C0.480111 14.6473 0.493373 15.0396 0.549436 16.2683C0.605362 17.4945 0.800121 18.3319 1.08492 19.0647C1.37927 19.8222 1.77318 20.4647 2.41361 21.1052C3.05409 21.7456 3.69653 22.1395 4.45407 22.4339C5.18683 22.7187 6.02426 22.9134 7.25043 22.9693C8.47916 23.0254 8.87147 23.0387 12.0001 23.0387C15.1288 23.0387 15.5211 23.0254 16.7498 22.9693C17.976 22.9134 18.8134 22.7187 19.5462 22.4339C20.3037 22.1395 20.9461 21.7456 21.5866 21.1052C22.227 20.4647 22.6209 19.8222 22.9153 19.0647C23.2001 18.3319 23.3949 17.4945 23.4508 16.2683C23.5068 15.0396 23.5201 14.6473 23.5201 11.5187C23.5201 8.39002 23.5068 7.99771 23.4508 6.76898C23.3949 5.54281 23.2001 4.70539 22.9153 3.97263C22.6209 3.21509 22.227 2.57264 21.5866 1.93217C20.9461 1.29174 20.3037 0.89783 19.5462 0.603474C18.8134 0.318676 17.976 0.123917 16.7498 0.0679907C15.5211 0.0119273 15.1288 -0.00133404 12.0001 -0.00133404ZM12.0001 2.07434C15.0761 2.07434 15.4404 2.08609 16.6552 2.14151C17.7784 2.19273 18.3883 2.3804 18.7943 2.53816C19.332 2.74714 19.7158 2.99678 20.1189 3.39992C20.522 3.80302 20.7716 4.18678 20.9806 4.7245C21.1384 5.13043 21.326 5.74041 21.3773 6.8636C21.4327 8.07833 21.4444 8.4427 21.4444 11.5187C21.4444 14.5946 21.4327 14.959 21.3773 16.1737C21.326 17.2969 21.1384 17.9069 20.9806 18.3128C20.7716 18.8506 20.522 19.2343 20.1189 19.6374C19.7158 20.0406 19.332 20.2902 18.7943 20.4992C18.3883 20.6569 17.7784 20.8446 16.6552 20.8958C15.4406 20.9512 15.0763 20.963 12.0001 20.963C8.92392 20.963 8.55964 20.9512 7.34504 20.8958C6.22185 20.8446 5.61188 20.6569 5.20595 20.4992C4.66822 20.2902 4.28447 20.0406 3.88137 19.6374C3.47827 19.2343 3.22859 18.8506 3.01961 18.3128C2.86185 17.9069 2.67418 17.2969 2.62296 16.1737C2.56754 14.959 2.55578 14.5946 2.55578 11.5187C2.55578 8.4427 2.56754 8.07833 2.62296 6.8636C2.67418 5.74041 2.86185 5.13043 3.01961 4.7245C3.22859 4.18678 3.47822 3.80302 3.88137 3.39992C4.28447 2.99678 4.66822 2.74714 5.20595 2.53816C5.61188 2.3804 6.22185 2.19273 7.34504 2.14151C8.55978 2.08609 8.92415 2.07434 12.0001 2.07434ZM6.08444 11.5187C6.08444 8.25151 8.73295 5.60299 12.0001 5.60299C15.2673 5.60299 17.9158 8.25151 17.9158 11.5187C17.9158 14.7858 15.2673 17.4343 12.0001 17.4343C8.73295 17.4343 6.08444 14.7858 6.08444 11.5187ZM12.0001 15.3587C9.87933 15.3587 8.16011 13.6394 8.16011 11.5187C8.16011 9.39788 9.87933 7.67867 12.0001 7.67867C14.1209 7.67867 15.8401 9.39788 15.8401 11.5187C15.8401 13.6394 14.1209 15.3587 12.0001 15.3587ZM18.1495 6.75165C18.913 6.75165 19.5319 6.13276 19.5319 5.36927C19.5319 4.60579 18.913 3.98685 18.1495 3.98685C17.3861 3.98685 16.7671 4.60579 16.7671 5.36927C16.7671 6.13276 17.3861 6.75165 18.1495 6.75165Z"
          fill="#838B8F"
        />
      </svg>
    ),
    link: "https://instagram.com/",
  },
  {
    id: "twitter",
    logo: (
      <svg
        width="24"
        height="21"
        viewBox="0 0 24 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.6"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.7602 3.19188C22.9136 3.57741 22.0022 3.83812 21.046 3.95461C22.0224 3.35552 22.7716 2.40558 23.1246 1.27396C22.2104 1.82867 21.2002 2.23223 20.121 2.44857C19.2609 1.50694 18.0317 0.918945 16.6712 0.918945C14.0625 0.918945 11.9461 3.08926 11.9461 5.76575C11.9461 6.14573 11.9866 6.51461 12.0678 6.86963C8.13921 6.66716 4.65691 4.73953 2.3241 1.80371C1.91705 2.52207 1.68444 3.35552 1.68444 4.24306C1.68444 5.92384 2.51884 7.4077 3.78735 8.27721C3.0138 8.25364 2.28353 8.03314 1.64522 7.67257V7.73221C1.64522 10.0814 3.27481 12.0409 5.43857 12.4847C5.04233 12.5984 4.62445 12.6553 4.19305 12.6553C3.88877 12.6553 3.59126 12.6262 3.3032 12.5693C3.905 14.4942 5.64953 15.8962 7.71863 15.9336C6.10122 17.2344 4.06187 18.0096 1.84808 18.0096C1.46671 18.0096 1.08941 17.9875 0.720215 17.9431C2.8123 19.316 5.29792 20.1189 7.96611 20.1189C16.6617 20.1189 21.4152 12.7343 21.4152 6.32878C21.4152 6.11799 21.4112 5.9072 21.4031 5.70057C22.3267 5.01689 23.1287 4.16402 23.7602 3.19188Z"
          fill="#838B8F"
        />
      </svg>
    ),
    link: "https://twitter.com/",
  },
  {
    id: "facebook",
    logo: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.6"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.0667 23.039H2.03189C1.32938 23.039 0.760254 22.4695 0.760254 21.7673V1.27064C0.760254 0.568231 1.32947 -0.000976562 2.03189 -0.000976562H22.5287C23.231 -0.000976562 23.8003 0.568231 23.8003 1.27064V21.7673C23.8003 22.4696 23.2309 23.039 22.5287 23.039H16.6575V14.1167H19.6523L20.1008 10.6395H16.6575V8.41949C16.6575 7.41276 16.9371 6.72671 18.3807 6.72671L20.222 6.7259V3.61587C19.9036 3.57349 18.8106 3.47882 17.5389 3.47882C14.8842 3.47882 13.0667 5.09928 13.0667 8.07512V10.6395H10.0642V14.1167H13.0667V23.039Z"
          fill="#838B8F"
        />
      </svg>
    ),
    link: "https://facebook.com/",
  },
  {
    id: "youtube",
    logo: (
      <svg
        width="24"
        height="17"
        viewBox="0 0 24 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.66"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.14112 11.5289L9.1404 5.00949L15.3655 8.28045L9.14112 11.5289ZM22.8096 3.87977C22.8096 3.87977 22.5842 2.28091 21.8938 1.57683C21.0175 0.652318 20.0354 0.647968 19.5854 0.59431C16.3613 0.359375 11.525 0.359375 11.525 0.359375H11.515C11.515 0.359375 6.67872 0.359375 3.45456 0.59431C3.00384 0.647968 2.02248 0.652318 1.14552 1.57683C0.45504 2.28091 0.2304 3.87977 0.2304 3.87977C0.2304 3.87977 0 5.7578 0 7.63511V9.39567C0 11.2737 0.2304 13.151 0.2304 13.151C0.2304 13.151 0.45504 14.7499 1.14552 15.4539C2.02248 16.3785 3.17376 16.3495 3.6864 16.4459C5.5296 16.6243 11.52 16.6794 11.52 16.6794C11.52 16.6794 16.3613 16.6721 19.5854 16.4372C20.0354 16.3828 21.0175 16.3785 21.8938 15.4539C22.5842 14.7499 22.8096 13.151 22.8096 13.151C22.8096 13.151 23.04 11.2737 23.04 9.39567V7.63511C23.04 5.7578 22.8096 3.87977 22.8096 3.87977Z"
          fill="#838B8F"
        />
      </svg>
    ),
    link: "https://youtube.com/",
  },
];

export default socialMedias;
